import type { newsletter as newsletterEn } from "../en/newsletter";

export const newsletter: typeof newsletterEn = {
  shared: {
    customersCount_one: "{{count}} zákazník",
    customersCount_few: "{{count}} zákazníci",
    customersCount_other: "{{count}} zákazníků",
    failedCount_one: "{{count}} selhal",
    failedCount_few: "{{count}} selhaly",
    failedCount_other: "{{count}} selhalo",
    sendingToast: "Odesílám",
  },
  campaignEditor: {
    titleNew: "Nová kampaň",
    titleEdit: "Upravit kampaň",
    statusSent: "Odesláno",
    statusScheduled: "Naplánováno",
    statusDraft: "Koncept",
    sendTest: "Odeslat test",
    toneOfVoice: "Tón komunikace",
    toneFriendly: "Přátelský",
    toneFormal: "Formální",
    toneExcited: "Nadšený",
    themeOptional: "Téma (volitelné)",
    themePlaceholder: "např. Letní dovolená, Dobrodružství, Romantika...",
    generating: "Generuji...",
    generateContent: "Vygenerovat obsah",
    emailSubject: "Předmět e-mailu",
    subjectPlaceholder: "Nové zájezdy do exotických destinací",
    previewTextLabel: "Text náhledu",
    previewTextPlaceholder: "Krátký text zobrazený v náhledu e-mailu...",
    charCount: "{{n}}/150 znaků",
    aiGenerationTitle: "Generování obsahu AI",
    aiGenerationHint: "Vyberte zájezdy a nechte AI vygenerovat newsletter",
    generateWithAi: "Vygenerovat pomocí AI",
    emailContent: "Obsah e-mailu",
    contentPlaceholder: "Obsah vašeho newsletteru...",
    scheduleSending: "Naplánovat odeslání",
    schedule: "Naplánovat",
    targetAudience: "Cílová skupina",
    changeSegment: "Změnit",
    selectSegment: "Vybrat segment",
    allSubscribers: "Všichni odběratelé newsletteru",
    orSelectSegment: "Nebo vyberte AI segment",
    selectSegmentColon: "Vyberte segment:",
    noSegments: "Žádné segmenty.",
    createNew: "Vytvořit nový",
    tripsInNewsletter: "Zájezdy v newsletteru ({{n}})",
    daysCount_one: "{{count}} den",
    daysCount_few: "{{count}} dny",
    daysCount_other: "{{count}} dní",
    noActiveTrips: "Žádné aktivní zájezdy",
    emailPreview: "Náhled e-mailu",
    subjectColon: "Předmět:",
    noSubject: "(bez předmětu)",
    previewColon: "Náhled:",
    emptyContent: "Prázdný obsah...",
    alreadySent: "Tato kampaň už byla odeslána a nelze ji upravovat.",
    toastCreated: "Kampaň vytvořena",
    toastCreateFailed: "Nepodařilo se vytvořit kampaň",
    toastSaved: "Kampaň uložena",
    toastSaveFailed: "Nepodařilo se uložit kampaň",
    toastGenerated: "Obsah vygenerován pomocí AI",
    toastGenerateFailed: "Nepodařilo se vygenerovat obsah",
    toastSent: "Kampaň odeslána",
    toastSendFailed: "Nepodařilo se odeslat kampaň",
    toastTestSent: "Test odeslán",
    toastTestFailed: "Odeslání testu se nezdařilo",
    saveFirst: "Nejdřív kampaň uložte",
    testPrompt: "Na jaký e-mail poslat test? (prázdné = váš vlastní)",
    errorMissingId: "Nepodařilo se vytvořit kampaň — chybí ID",
    errorCampaignIdMissing: "Chybí ID kampaně",
  },
  editionEditor: {
    title: "Editor vydání",
    aiDraftPrefix: "AI koncept — ",
    previewFailed: "Náhled se nepodařilo vykreslit",
    rewritten: "Přepsáno",
    rewriteFailed: "Přepsání se nezdařilo",
    saved: "Vydání uloženo",
    saveFailed: "Uložení se nezdařilo",
    notFound: "Kampaň nenalezena.",
    regenerate: "Přegenerovat",
    regenerateTitle: "Přegenerovat text konceptu",
    sendEllipsis: "Odeslat…",
    previewIframeTitle: "Náhled newsletteru",
    renderingPreview: "Vykresluji náhled…",
    subject: "Předmět",
    preheader: "Preheader",
    abVariants: "A/B varianty předmětu (test 1. vlny)",
    globalInstructionPlaceholder:
      "Globální pokyn — např. „kratší, údernější, méně prodejní“ (zamčené sekce zůstanou beze změny)",
    lockedChip: "zamčeno",
    unlockTitle: "Odemknout — AI smí znovu upravovat",
    lockTitle: "Zamknout — AI se sekce nedotkne",
    sectionPromptPlaceholder: "Napište AI, co má v této sekci změnit…",
  },
  sendDialog: {
    title: "Odeslat kampaň",
    eligible: "k odeslání",
    unsubscribed: "odhlášení",
    freqCapped: "frekv. limit",
    paused: "pozastaveno",
    dormant: "neaktivní",
    basis: "Základ: odběr {{explicit}} · zákazníci {{customer}} · poptávky {{lead}}.",
    abTestInfo:
      "A/B test předmětu: 1. vlna = 25 %, vítěz podle prokliků se rozešle ~{{hours}} h poté.",
    singleWave:
      "Jedna vlna — A/B test předmětu potřebuje 2+ varianty předmětu a dostatečně velké publikum.",
    narrowToSegment: "Zúžit na segment (volitelné)",
    everyoneEligible: "Všichni způsobilí",
    sendTestTo: "Odeslat test na",
    testEmailPlaceholder: "vy sami (výchozí: váš přihlašovací e-mail)",
    scheduleOptional: "Naplánovat (volitelné — prázdné = odeslat hned)",
    whyThisDraft: "Proč tento koncept? (volitelné — vstup pro učení)",
    whyPlaceholder: "např. nejsilnější hook, sedí k tématu Tet…",
    sendNow: "Odeslat hned",
    confirmSchedule: "Naplánovat tuto kampaň na {{time}}?",
    confirmSendNow: "Odeslat hned {{n}} kontaktům?",
    testSentToast: "Test odeslán — zkontrolujte schránku",
    testFailed: "Test se nezdařil",
    sendFailed: "Odeslání se nezdařilo",
  },
  studio: {
    title: "Newsletter studio",
    subtitle: "AI koncepty každé pondělí — vy vyberete, doladíte a odešlete.",
    tabs: {
      drafts: "Koncepty",
      queue: "Fronta",
      directives: "Pokyny",
      personas: "Persony",
      voice: "Hlas značky",
      calendar: "Kalendář",
      results: "Výsledky",
      subscribers: "Odběratelé",
      segments: "Segmenty",
    },
  },
  generate: {
    started: "Generování spuštěno — koncepty budou za pár minut",
    startFailed: "Nepodařilo se spustit",
    generateNow: "Vygenerovat teď",
    directiveLabel: "Pokyn (volitelný)",
    directivePlaceholder: "např. „zaměř se na termíny kolem svátku Tet“ nebo téma tohoto vydání",
    mustIncludeLabel: "Povinné zájezdy (volitelné, max {{max}})",
    mustIncludePlaceholder: "Hledat publikované zájezdy...",
    mustIncludeHint: "Vybrané zájezdy se zaručeně objeví v každém konceptu na prvním místě.",
    start: "Spustit",
    tokens: "{{n}}k tokenů",
    runStatus: {
      running: "běží",
      done: "hotovo",
      failed: "selhalo",
      aborted: "přerušeno",
    },
  },
  drafts: {
    noDraftsPrefix: "Zatím žádné AI koncepty — klikněte na",
    noDraftsSuffix: "nebo počkejte na pondělí 06:00 UTC.",
    olderDrafts: "Starší koncepty",
    manualTitle: "Ruční kampaně",
    newManual: "Nová ruční kampaň",
    manualEmpty:
      "Žádné ručně psané koncepty. Ruční kampaně obcházejí AI pipeline — HTML píšete sami; odesílání, plánování a měření fungují stejně.",
    confirmDeleteDraft: "Smazat koncept „{{subject}}“?",
    deleteDraftTitle: "Smazat koncept",
    deleted: "Kampaň smazána",
    deleteFailed: "Nepodařilo se smazat kampaň",
    draftFallback: "Koncept",
    pickAndEdit: "Vybrat a upravit",
  },
  directives: {
    newTitle: "Nový pokyn",
    kindInspiration: "Inspirace (postrčení)",
    kindAssignment: "Zadání (musí pokrýt)",
    assignmentPlaceholder:
      "Pokryjí to všechny 3 koncepty — např. „termíny na Tet 2027 jsou otevřené“",
    inspirationPlaceholder: "Postrčení pro krok volby tématu — např. „zmiň novou smyčku Ha Giang“",
    verbatimPlaceholder: "Volitelný DOSLOVNÝ text — vloží se slovo od slova jako zamčená poznámka",
    add: "Přidat pokyn",
    added: "Pokyn přidán",
    listTitle: "Pokyny",
    kinds: {
      inspiration: "inspirace",
      assignment: "zadání",
    },
    statuses: {
      pending: "čeká",
      consumed: "použito",
      archived: "archivováno",
    },
    verbatimNote: "doslovně: {{text}}",
    empty: "Zatím žádné pokyny.",
  },
  personas: {
    newTitle: "Nová persona",
    namePlaceholder: "Název — např. „Dobrodružný pár“",
    descriptionPlaceholder:
      "Kdo to je a co ho přesvědčí — krok kritiky se vžije do tohoto čtenáře.",
    add: "Přidat personu",
    listTitle: "Persony",
    discovered: "objevená",
    review: "ke kontrole",
    active: "aktivní",
    empty: "Zatím žádné persony.",
  },
  voice: {
    saved: "Dokument hlasu uložen",
    reanalyzed: "Znovu zanalyzováno z historických newsletterů",
    title: "Průvodce hlasem značky",
    reanalyze: "Znovu analyzovat z historie",
    hint: "Copywriterský krok si to přečte před psaním každého vydání. Upravujte podle libosti — je to vaše.",
  },
  calendar: {
    from: "Od",
    to: "Do",
    labelPlaceholder: "Název — např. Tet (lunární Nový rok)",
    notePlaceholder: "Poznámka pro analytika (volitelné)",
    empty: "Žádné záznamy — přidejte Tet, letní prázdniny, období nejlepší návštěvy…",
  },
  queue: {
    relIn: "za {{span}}",
    relAgo: "před {{span}}",
    spanHM: "{{h}} h {{m}} min",
    spanM: "{{m}} min",
    nextEditionPrefix: "Další AI vydání:",
    nextEditionSuffix: "(pondělí 06:00 UTC)",
    sendRatePrefix: "Rychlost odesílání:",
    ratePerMin: "{{n}}/min",
    wave2Prefix: "2. vlna testu předmětu:",
    wave2Value: "+{{n}} h",
    wave2Suffix: "po 1. vlně",
    scheduledHeading: "Naplánováno ({{n}})",
    scheduledEmpty:
      "Nic není naplánováno — vyberte koncept a v dialogu odeslání použijte „Naplánovat“.",
    sendingHeading: "Právě se odesílá ({{n}})",
    sendingEmpty: "Žádná kampaň se neodesílá.",
    audienceSegment: "segmentu „{{name}}“",
    audienceFull: "celému publiku",
    confirmSendNow: "Odeslat „{{subject}}“ HNED {{audience}}?",
    confirmCancel: "Zrušit toto naplánování? Kampaň se vrátí mezi koncepty.",
    cancelled: "Naplánování zrušeno",
    rescheduled: "Přeplánováno",
    actionFailed: "Akce se nezdařila",
    segmentInfo: "segment: {{name}}",
    aiEdition: "AI vydání",
    manualLabel: "ruční",
    reschedule: "Přeplánovat",
    sendNow: "Odeslat hned",
    cancelScheduleTitle: "Zrušit naplánování",
    sentOfTotal: "{{sent}}/{{total}} odesláno",
    waveWaiting:
      "Test předmětu: 1. vlna venku, vítěz podle prokliků ~{{time}} → 2. vlna ({{n}} čeká)",
    waveRolling: "2. vlna se rozesílá s variantou {{variant}}",
    queuedCount: "{{n}} ve frontě",
    startedAt: "zahájeno {{time}}",
  },
  results: {
    retroSaved: "Retro poznámka uložena — analytik ji uvidí",
    retroSaveFailed: "Poznámku se nepodařilo uložit",
    colCampaign: "Kampaň",
    colSent: "Odesláno",
    colOpens: "Otevření",
    colClicks: "Prokliky",
    colCtr: "CTR",
    showBreakdown: "Zobrazit rozpad prokliků",
    retroPlaceholder: "Co jsme se naučili?",
    addRetroNote: "+ retro poznámka",
    noSentCampaigns: "Zatím žádné odeslané kampaně.",
    noClicks: "Zatím žádné prokliky.",
    audienceInterest: "Zájem publika — prokliky podle destinací (všechny kampaně)",
    mostClickedLinks: "Nejklikanější odkazy",
    delivered: "Doručeno",
    uniqueOpens: "unikátní otevření",
    uniqueClickers: "unikátně kliklo",
    housekeepingClicks_one: "{{count}} servisní proklik (odhlášení/zobrazení)",
    housekeepingClicks_few: "{{count}} servisní prokliky (odhlášení/zobrazení)",
    housekeepingClicks_other: "{{count}} servisních prokliků (odhlášení/zobrazení)",
    topLinks: "Nejčastější odkazy",
    bySection: "Podle sekce",
    byDestination: "Podle destinace",
  },
  sections: {
    labels: {
      bar: "Horní lišta",
      hero: "Hero",
      intro: "Úvod",
      trustBoxes: "Boxy důvěry",
      spotlight: "Medailonek",
      tripCards: "Karty zájezdů",
      review: "Recenze",
      included: "Co je v ceně",
      video: "Video",
      routeTimeline: "Osa trasy",
      combos: "Komba",
      note: "Poznámka",
      helpDesk: "Poradna",
      footer: "Patička",
    },
    fields: {
      left: "Vlevo",
      right: "Vpravo",
      eyebrow: "Nadtitulek",
      accent: "Akcent (zvýrazněná část)",
      title: "Titulek",
      subtitle: "Podtitulek",
      image: "Obrázek",
      greeting: "Pozdrav (lze použít {{placeholder}})",
      body: "Text",
      variant: "Varianta",
      variantGuide: "Průvodce",
      variantBranch: "Pobočka",
      variantCustom: "Vlastní",
      bullets: "Odrážky (jedna na řádek)",
      photo: "Fotografie",
      mode: "Režim",
      modePersonalized: "Personalizovaný (podle příjemce)",
      modeManual: "Ruční (přesně tyto zájezdy)",
      discoverySlot: "Discovery slot",
      tripsExact: "Zájezdy (přesně tyto)",
      tripsFallback: "Záložní zájezdy (příjemci bez profilu)",
      hookPlaceholder: "hook (jeden řádek, bez čísel)",
      addTrip: "+ přidat zájezd…",
      quote: "Citace",
      author: "Autor",
      context: "Kontext (zájezd)",
      linkOptional: "Odkaz (volitelný)",
      includedList: "V ceně (jedna položka na řádek)",
      excludedList: "Není v ceně (jedna položka na řádek)",
      youtubeUrl: "YouTube URL",
      caption: "Popisek",
      thumbnail: "Náhledový obrázek",
      titleTripName: "Titulek (název zájezdu)",
      stops: "Zastávky (jedna na řádek, 2–8)",
      comboTitle: "Titulek",
      comboSubtitle: "Podtitulek",
      comboPrice: "Cenový popisek",
      tone: "Tón",
      toneInfo: "Info (zlatá)",
      toneWarning: "Upozornění (akcent)",
      ctaLabel: "Text CTA",
      ctaUrl: "URL CTA",
      phone: "Telefon",
      trustLabelPlaceholder: "POPISEK",
      trustValuePlaceholder: "Hodnota",
      footerNote:
        "Patička se generuje celá při odeslání (odkaz na odhlášení, adresa, zobrazení v prohlížeči).",
    },
  },
  themes: {
    violet: "Go2 Magenta",
    magenta: "Zine Magenta",
    jade: "Jade Coast",
    sunset: "Golden Hour",
  },
  segments: {
    deleted: "Segment smazán",
    deleteFailed: "Nepodařilo se smazat segment",
    regenerated: "Segment přegenerován",
    regenerateFailed: "Nepodařilo se přegenerovat segment",
    intro:
      "Popište segment přirozeným jazykem (např. „zákazníci, kteří s námi loni cestovali do Vietnamu“) a AI ho sestaví automaticky. Segmenty zužují publikum v dialogu odeslání.",
    newSegment: "Nový segment",
    searchPlaceholder: "Hledat segmenty...",
    automatic: "Automatický",
    lastUpdated: "Naposledy aktualizováno: {{date}}",
    regenerateTitle: "Přegenerovat zákazníky",
    viewCustomers: "Zobrazit zákazníky",
    deleteTitle: "Smazat segment",
    noSegments: "Žádné segmenty",
    createFirst: "Vytvořit první segment",
    confirmDeleteMessage: "Opravdu chcete tento segment smazat? Akci nelze vrátit zpět.",
    previewFailed: "Nepodařilo se vytvořit náhled",
    created: "Segment vytvořen",
    createFailed: "Nepodařilo se vytvořit segment",
    enterDescription: "Zadejte popis segmentu",
    enterName: "Zadejte název segmentu",
    describeHint: "Popište segment přirozeným jazykem",
    nameLabel: "Název segmentu",
    namePlaceholder: "např. VIP zákazníci",
    promptLabel: "Popis segmentu (AI prompt)",
    promptPlaceholder:
      "např. zákazníci, kteří s námi loni cestovali do Vietnamu a utratili víc než 50 000 Kč",
    tips: "Tipy: „zákazníci bez objednávky letos“, „zákazníci s narozeninami tento měsíc“, „zákazníci z Kalifornie, kteří preferují jihovýchodní Asii“",
    createSegment: "Vytvořit segment",
    previewTitle: "Náhled segmentu",
    moreCustomers_one: "... a {{count}} další zákazník",
    moreCustomers_few: "... a {{count}} další zákazníci",
    moreCustomers_other: "... a {{count}} dalších zákazníků",
    noCustomers: "Žádní zákazníci v segmentu",
    totalSpent: "Celkem utraceno",
    tripsCol: "Zájezdy",
  },
  subscribers: {
    activeWord_one: "aktivní",
    activeWord_few: "aktivní",
    activeWord_other: "aktivních",
    unsubscribedWord_one: "odhlášený",
    unsubscribedWord_few: "odhlášení",
    unsubscribedWord_other: "odhlášených",
    suppressedWord_one: "potlačený",
    suppressedWord_few: "potlačení",
    suppressedWord_other: "potlačených",
    pendingWord_one: "čekající",
    pendingWord_few: "čekající",
    pendingWord_other: "čekajících",
    searchPlaceholder: "Hledat odběratele…",
    noSubscribers: "Žádní odběratelé",
    colSource: "Zdroj",
    colSubscribed: "Přihlášeno",
    statusSuppressed: "Potlačený",
    statusPending: "Čeká",
    statusUnsubscribed: "Odhlášený",
  },
};
